import Button from "@mui/material/Button";
import { useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Typography } from "@mui/material";
import Alert from "@mui/material/Alert";
import { disableCodeApi } from "../../../../../services/marketingApi";
export default function DisableCode(props) {
  const { handleCloseDialogContent, dataContent, handleStatusCodeState } =
    props;
  const [alertDisplay, setAlertDisplay] = useState("none");
  const handleDisableCode = async () => {
    setAlertDisplay("flex");
    await disableCodeApi({
      codeId: dataContent["packageId"],
      status: dataContent["newStatus"],
    });
    handleStatusCodeState(dataContent["packageId"], dataContent["newStatus"]);
    handleCloseDialogContent();
  };
  // let data = JSON.parse(dataContent);
  return (
    <>
      <DialogContent dividers>
        {/* <Typography></Typography> */}
        <Alert severity="error">{`آیا مطمئنید که میخواهید کد را ${dataContent.newStatus ? "فعال" : "غیرفعال"
          } کنید`}</Alert>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          variant="contained"
          color="info"
          onClick={handleCloseDialogContent}
        >
          لغو
        </Button>
        <Button variant="contained" color="warning" onClick={handleDisableCode}>
          ذخیره
        </Button>
      </DialogActions>
      <Alert sx={{ display: alertDisplay }} severity="warning">
        لطفا صبر کنید
      </Alert>
    </>
  );
}
